import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * createRange
 * @param {number} min
 * @param {number} max
 * @param {number} step
 * @returns {number[]}
 */
function createRange(min, max, step) {
  const result = [];
  let value = min;

  while (value <= max) {
    result.push(value);
    value += step;
  }

  return result;
}

/**
 * RoomTypeItem
 */
export default class RoomTypeItem extends Base {
  static config = {
    name: 'RoomTypeItem',
    options: {
      intersectionObserver: Object,
    },
    emits: ['intersected'],
    log: true,
  };

  /**
   * Create an observer when the class in instantiated.
   * @param {HTMLElement} element
   */
  constructor(element) {
    super(element);

    this.$observer = new IntersectionObserver(
      (entries) => {
        this.__callMethod('intersected', entries);
      },
      {
        threshold: createRange(0, 1, 0.01),
        ...this.$options.intersectionObserver,
      },
    );

    this.$on('mounted', () => {
      this.$observer.observe(this.target);
    });

    this.$on('destroyed', () => {
      this.$observer.unobserve(this.target);
    });
  }

  /**
   * Target Element
   * @returns {HTMLElement}
   */
  get target() {
    return document.querySelector(this.$el.hash);
  }

  /**
   * Intersected
   * @param {Array} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      const roomTypesItems = this.$parent.$children?.RoomTypeItem ?? [];
      toggleClass(this.$el, 'is-active', true);
      toggleClass(
        roomTypesItems.filter((instance) => instance !== this).map((instance) => instance.$el),
        'is-active',
        false,
      );
    } else if (
      !entries[0].isIntersecting &&
      document.documentElement.classList.contains('is-scrolling-up')
    ) {
      const roomTypesItems = this.$parent.$children?.RoomTypeItem ?? [];

      const currentIndex = roomTypesItems
        .sort((instance) => instance.$el.getBoundingClientRect().top + window.scrollY)
        .indexOf(this);

      if (currentIndex === 0) {
        return;
      }

      const previousInstance = roomTypesItems[currentIndex - 1];

      toggleClass(previousInstance.$el, 'is-active', true);

      toggleClass(
        roomTypesItems
          .filter((instance) => instance !== previousInstance)
          .map((instance) => instance.$el),
        'is-active',
        false,
      );
    }
  }
}
